import SubmissionApi from 'Api/submission';
import FileApi from 'Api/file';
import { push } from 'react-router-redux';
import { loadTemplateByPhases } from 'Actions/email';
import {
    PHASE_AUTHOR_DECISION,
    PHASE_DECISION_MAKING,
    PHASE_DESK_REVIEW,
    PHASE_PEER_REVIEW,
    PHASE_PEER_REVIEW_HANDLE,
} from 'Constants';
import { clearAutocomplete as clearJournalAutocomplete } from './journal';
import { keepAlive } from 'Actions/auth';

export const SUBMISSION_CREATE_REQUEST = 'SUBMISSION_CREATE_REQUEST';
export const SUBMISSION_CREATE_SUCCESS = 'SUBMISSION_CREATE_SUCCESS';
export const SUBMISSION_CREATE_ERROR = 'SUBMISSION_CREATE_ERROR';

export const SUBMISSION_LIST_REQUEST = 'SUBMISSION_LIST_REQUEST';
export const SUBMISSION_LIST_SUCCESS = 'SUBMISSION_LIST_SUCCESS';
export const SUBMISSION_LIST_ERROR = 'SUBMISSION_LIST_ERROR';
export const SUBMISSION_LIST_UPDATE_FILTER = 'SUBMISSION_LIST_UPDATE_FILTER';
export const SUBMISSION_LIST_UPDATE_SEARCH_FILTER = 'SUBMISSION_LIST_UPDATE_SEARCH_FILTER';

export const SUBMISSION_LIST_AUTOCOMPLETE_REQUEST = 'SUBMISSION_LIST_AUTOCOMPLETE_REQUEST';
export const SUBMISSION_LIST_AUTOCOMPLETE_SUCCESS = 'SUBMISSION_LIST_AUTOCOMPLETE_SUCCESS';
export const SUBMISSION_LIST_AUTOCOMPLETE_ERROR = 'SUBMISSION_LIST_AUTOCOMPLETE_ERROR';

export const SUBMISSION_COUNT_REQUEST = 'SUBMISSION_COUNT_REQUEST';
export const SUBMISSION_COUNT_SUCCESS = 'SUBMISSION_COUNT_SUCCESS';
export const SUBMISSION_COUNT_ERROR = 'SUBMISSION_COUNT_ERROR';
export const SUBMISSION_COUNT_UPDATE_FILTER = 'SUBMISSION_COUNT_UPDATE_FILTER';

export const SUBMISSION_LIST_CLEAR = 'SUBMISSION_LIST_CLEAR';

export const SUBMISSION_STATUSES_REQUEST = 'SUBMISSION_STATUSES_REQUEST';
export const SUBMISSION_STATUSES_SUCCESS = 'SUBMISSION_STATUSES_SUCCESS';
export const SUBMISSION_STATUSES_ERROR = 'SUBMISSION_STATUSES_ERROR';

export const SUBMISSION_PHASES_REQUEST = 'SUBMISSION_PHASES_REQUEST';
export const SUBMISSION_PHASES_SUCCESS = 'SUBMISSION_PHASES_SUCCESS';
export const SUBMISSION_PHASES_ERROR = 'SUBMISSION_PHASES_ERROR';

export const SUBMISSION_DATA_REQUEST = 'SUBMISSION_DATA_REQUEST';
export const SUBMISSION_DATA_SUCCESS = 'SUBMISSION_DATA_SUCCESS';
export const SUBMISSION_DATA_ERROR = 'SUBMISSION_DATA_ERROR';

export const SUBMISSION_ADD_COMMENT_REQUEST = 'SUBMISSION_ADD_COMMENT_REQUEST';
export const SUBMISSION_ADD_COMMENT_SUCCESS = 'SUBMISSION_ADD_COMMENT_SUCCESS';
export const SUBMISSION_ADD_COMMENT_ERROR = 'SUBMISSION_ADD_COMMENT_ERROR';

export const SUBMISSION_COMMENTS_REQUEST = 'SUBMISSION_COMMENTS_REQUEST';
export const SUBMISSION_COMMENTS_SUCCESS = 'SUBMISSION_COMMENTS_SUCCESS';
export const SUBMISSION_COMMENTS_ERROR = 'SUBMISSION_COMMENTS_ERROR';

export const SUBMISSION_VERSIONS_DATA_REQUEST = 'SUBMISSION_VERSIONS_DATA_REQUEST';
export const SUBMISSION_VERSIONS_DATA_SUCCESS = 'SUBMISSION_VERSIONS_DATA_SUCCESS';
export const SUBMISSION_VERSIONS_DATA_ERROR = 'SUBMISSION_VERSIONS_DATA_ERROR';

export const SUBMISSION_ADD_FILES_REQUEST = 'SUBMISSION_ADD_FILES_REQUEST';
export const SUBMISSION_ADD_FILES_SUCCESS = 'SUBMISSION_ADD_FILES_SUCCESS';
export const SUBMISSION_ADD_FILES_ERROR = 'SUBMISSION_ADD_FILES_ERROR';

export const SUBMISSION_ACTIVITIES_DATA_REQUEST = 'SUBMISSION_ACTIVITIES_DATA_REQUEST';
export const SUBMISSION_ACTIVITIES_DATA_SUCCESS = 'SUBMISSION_ACTIVITIES_DATA_SUCCESS';
export const SUBMISSION_ACTIVITIES_DATA_ERROR = 'SUBMISSION_ACTIVITIES_DATA_ERROR';

export const SUBMISSION_ATTACHMENT_DATA_REQUEST = 'SUBMISSION_ATTACHMENT_DATA_REQUEST';
export const SUBMISSION_ATTACHMENT_DATA_SUCCESS = 'SUBMISSION_ATTACHMENT_DATA_SUCCESS';
export const SUBMISSION_ATTACHMENT_DATA_ERROR = 'SUBMISSION_ATTACHMENT_DATA_ERROR';

export const SUBMISSION_CHANGE_REQUEST = 'SUBMISSION_CHANGE_REQUEST';
export const SUBMISSION_CHANGE_SUCCESS = 'SUBMISSION_CHANGE_SUCCESS';
export const SUBMISSION_CHANGE_ERROR = 'SUBMISSION_CHANGE_ERROR';

export const SUBMISSION_ASSIGN_REVIEWERS_REQUEST = 'SUBMISSION_ASSIGN_REVIEWERS_REQUEST';
export const SUBMISSION_ASSIGN_REVIEWERS_SUCCESS = 'SUBMISSION_ASSIGN_REVIEWERS_SUCCESS';
export const SUBMISSION_ASSIGN_REVIEWERS_ERROR = 'SUBMISSION_ASSIGN_REVIEWERS_ERROR';

export const SUBMISSION_INVITE_EXTERNAL_REQUEST = 'SUBMISSION_INVITE_EXTERNAL_REQUEST';
export const SUBMISSION_INVITE_EXTERNAL_SUCCESS = 'SUBMISSION_INVITE_EXTERNAL_SUCCESS';
export const SUBMISSION_INVITE_EXTERNAL_ERROR = 'SUBMISSION_INVITE_EXTERNAL_ERROR';

/**
 * Create submission
 *
 * @param data
 * @param isAuthor
 * @returns {{requestType: string, request: (function(*))}}
 */
export function createSubmission(data, isAuthor) {
    return {
        requestType: 'SUBMISSION_CREATE',
        request: SubmissionApi.createSubmission(data, isAuthor),
        success: (response, dispatch) => {
            dispatch(keepAlive());
            dispatch(push('/'));
            dispatch(clearJournalAutocomplete());
            return {
                payload: response.data,
            };
        },
    };
}

/**
 * Load all instances of the model matched by filters from the data source
 *
 * @param filter
 * @returns {Object}
 */
export function load(filter = {}) {
    const { page } = filter;
    return {
        requestType: 'SUBMISSION_LIST',
        request: SubmissionApi.find({ ...filter, page: page || 1 }),
    };
}

/**
 * Load all instances of the model matched by filters from the data source
 *
 * @param filter
 * @returns {Object}
 */
export function loadCount(filter = {}) {
    const { page } = filter;
    return {
        requestType: 'SUBMISSION_COUNT',
        request: SubmissionApi.find({ ...filter, page: page || 1 }),
    };
}

/**
 * Load all instances of the model matched by filters from the data source
 *
 * @param filter
 * @returns {Object}
 */
export function loadAutocomplete(filter = {}) {
    const { page } = filter;
    return {
        requestType: 'SUBMISSION_LIST_AUTOCOMPLETE',
        request: SubmissionApi.find({ ...filter, page: page || 1 }),
    };
}

/**
 * Update filter
 *
 * @param {Object} filter
 *
 * @return {Object}
 */
export function updateFilter(filter = {}) {
    return {
        type: SUBMISSION_LIST_UPDATE_FILTER,
        payload: filter,
    };
}

/**
 * Update filter
 *
 * @param {Object} filter
 *
 * @return {Object}
 */
export function updateSearchFilter(filter = {}) {
    return {
        type: SUBMISSION_LIST_UPDATE_SEARCH_FILTER,
        payload: filter,
    };
}

/**
 * @returns {Object}
 */
export function loadStatuses() {
    return {
        requestType: 'SUBMISSION_STATUSES',
        request: SubmissionApi.findStatuses(),
    };
}

/**
 * @returns {Object}
 */
export function loadPhases() {
    return {
        requestType: 'SUBMISSION_PHASES',
        request: SubmissionApi.findPhases(),
    };
}

/**
 * Load model data
 *
 * @param {number} id
 * @returns {*}
 */
export function loadSubmissionData(id) {
    return {
        requestType: 'SUBMISSION_DATA',
        request: SubmissionApi.loadSubmissionData(id),
    };
}

/**
 * Add submission comment
 *
 * @param data
 */
export function addSubmissionComment(data) {
    return {
        requestType: 'SUBMISSION_ADD_COMMENT',
        request: SubmissionApi.addComment(data),
    };
}

/**
 * Load model data
 *
 * @param filter
 * @returns {*}
 */
export function loadSubmissionComments(filter = {}) {
    return {
        requestType: 'SUBMISSION_COMMENTS',
        request: SubmissionApi.loadSubmissionComments(filter),
    };
}

/**
 * Load model data
 *
 * @param filter
 * @returns {*}
 */
export function loadVersionHistoryData(filter = {}) {
    return {
        requestType: 'SUBMISSION_VERSIONS_DATA',
        request: SubmissionApi.loadVersionHistoryData(filter),
    };
}

/**
 * Load model data
 *
 * @param filter
 * @param isReviewer
 * @returns {*}
 */
export function loadAttachmentsData(filter, isReviewer = 0) {
    return {
        requestType: 'SUBMISSION_ATTACHMENT_DATA',
        request: SubmissionApi.loadAttachmentsData(filter, isReviewer),
    };
}

/**
 * Add submission file
 *
 * @param id
 * @param data
 */
export function addSubmissionFile(id, data) {
    return {
        requestType: 'SUBMISSION_ADD_FILES',
        request: SubmissionApi.addSubmissionFile(id, data),
    };
}

/**
 * @param fileId
 * @param title
 * @param saveToLog
 */
export function downloadFile(fileId, title, saveToLog = true) {
    return {
        requestType: 'FILE_DOWNLOAD',
        request: FileApi.download(fileId, title, saveToLog),
    };
}

/**
 * Clear submission list store
 *
 * @returns {*}
 */
export function clearSubmissionList() {
    return {
        type: SUBMISSION_LIST_CLEAR,
    };
}

/**
 * Load model data
 *
 * @param {number} id
 * @returns {*}
 */
export function loadSubmissionActivities(id) {
    return {
        requestType: 'SUBMISSION_ACTIVITIES_DATA',
        request: SubmissionApi.loadSubmissionActivities(id),
    };
}

/**
 * @param id
 * @param data
 */
export function changePhase(id, data) {
    return {
        requestType: 'SUBMISSION_CHANGE',
        request: SubmissionApi.changePhase(id, data),
        success: (response, dispatch) => {
            if (response.data.status.alias === PHASE_DESK_REVIEW) {
                dispatch(loadTemplateByPhases([PHASE_PEER_REVIEW, PHASE_PEER_REVIEW_HANDLE]));
            }
            if (response.data.status.alias === PHASE_DECISION_MAKING) {
                dispatch(loadTemplateByPhases([PHASE_AUTHOR_DECISION]));
            }
            return {
                payload: response
            };
        },
    };
}

/**
 * @param id
 * @param data
 */
export function changeStatus(id, data) {
    return {
        requestType: 'SUBMISSION_CHANGE',
        request: SubmissionApi.changeStatus(id, data),
        success: (response, dispatch) => {
            if (data.isReviewer) {
                dispatch(push('/'));
            }

            return {
                payload: response
            };
        }
    };
}

/**
  * Assign reviewers
  *
  * @param data
  * @returns {{requestType: string, request: (function(*))}}
  */
export function assignReviewers(data) {
    return {
        requestType: 'SUBMISSION_ASSIGN_REVIEWERS',
        request: SubmissionApi.assignReviewers(data)
    };
}

/**
 * Invite external reviewers
 *
 * @param data
 * @returns {{requestType: string, request: (function(*))}}
 */
export function inviteExternalReviewers(data) {
    return {
        requestType: 'SUBMISSION_INVITE_EXTERNAL',
        request: SubmissionApi.inviteExternalReviewers(data)
    };
}

/**
 * @param id
 * @param decision
 * @returns {{requestType: string, request: (function(*): (Promise<ApiResponse<any>>|AxiosPromise<any>))}}
 */
export function authorDecision(id, decision) {
    return {
        requestType: 'SUBMISSION_CHANGE',
        request: SubmissionApi.authorDecision(id, decision)
    };
}



// WEBPACK FOOTER //
// ./src/actions/submission.js